"use client";

import { Badge, Divider, Flex, NavLink, Stack, Text } from "@mantine/core";
import { Moon } from "iconsax-react";
import { parseAsBoolean, useQueryState } from "nuqs";

import { ProfileData } from "@/builders/types/profile";
import { useToggleColorScheme } from "@/hooks/use-toggle-color-scheme";

import Link from "next/link";

interface ProfilePopoverContentProps extends Partial<ProfileData> {}

export function ProfilePopoverContent(props: ProfilePopoverContentProps) {
  const { first_name, staff_id, rank_id } = props;
  const { toggleColorScheme } = useToggleColorScheme();

  const [, setOpened] = useQueryState("drawer", parseAsBoolean);

  return (
    <>
      <Stack gap={2} p={16}>
        <Flex gap={4} align="center">
          <Text fw={500} className="text-primary-text-body">
            {first_name}
          </Text>

          <Badge
            fw={600}
            bg="accent.3"
            radius="sm"
            className="rounded text-primary-button-normal"
            p={4}
          >
            Pro
          </Badge>
        </Flex>

        <Text fz={14} className="text-primary-text-subtle">
          {staff_id}
        </Text>
      </Stack>

      <Divider />

      <NavLink
        component="button"
        label="My Profile"
        px={16}
        py={12}
        fz={14}
        onClick={() => setOpened(true)}
        className="text-primary-text-subtle"
      />

      <Divider />

      <NavLink
        px={16}
        py={12}
        fz={14}
        onClick={toggleColorScheme}
        className="text-primary-text-subtle"
        rightSection={<Moon size={20} className="text-primary-text-subtle" />}
        label="Mode"
      />

      <NavLink
        px={16}
        py={12}
        fz={14}
        component={Link}
        label="Sign Out"
        className="text-primary-text-subtle"
        href="/logout"
      />
    </>
  );
}
